/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Searchreadytitle2Inputs */

const en_searchreadytitle2 = /** @type {(inputs: Searchreadytitle2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Found on Google & AI`)
};

const de_searchreadytitle2 = /** @type {(inputs: Searchreadytitle2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Gefunden in Google & KI`)
};

/**
* | output |
* | --- |
* | "Found on Google & AI" |
*
* @param {Searchreadytitle2Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const searchreadytitle2 = /** @type {((inputs?: Searchreadytitle2Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Searchreadytitle2Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_searchreadytitle2(inputs)
	return de_searchreadytitle2(inputs)
});
export { searchreadytitle2 as "searchReadyTitle" }